module.exports = __webpack_public_path__ + "51dc8cd3f13fde32ca6398bed6d1a795.MP3";